import Container from "react-bootstrap/Container";
import "bootstrap/dist/css/bootstrap.min.css";

function DrivenBySpirit() {
  return (
    <>
      <Container>
        <div class="row">
          <div class="col-12">
            <div class="contentbox">
            <h1 className="cus_text60">
              FORGED IN STRENGTH, DRIVEN BY SPIRIT
            </h1>
            <p className="cus_text30">
            India is majestic. The spirit of its people, unshakeable – inspiring the world to meet every day with the firm resolve of steel. Though silent, there is an unseen strength in this steely spirit that keeps us going. We wanted to spotlight this signature Indianness and celebrate it with the world. This creative seed took root in the ‘Steel of India’ campaign. Through a blend of compelling imagery and music, Ayappa K.M channelled our vision in a two-minute feature film that traverses diverse national landscapes and explores our rich culture. Over time, the campaign evolved into a stunning visual ode to how the strength and reliability of Jindal Steel protects and empowers the essence of India.
            </p>
            </div>
          </div>
        </div>
        
      </Container>
    </>
  );
}

export default DrivenBySpirit;
